module.exports = __webpack_public_path__ + "static/media/social_issues.4956cc64.png";